import TulsaHeroSection from "./components/HeroSection";
import TulsaStickyNav from "./components/StickyNav";
import TulsaProcessingTimeSection from "./components/ProcessingTimeSection";
import TulsaServicesSection from "./components/ServicesSection";
import TulsaLocalAreaSection from "./components/LocalAreaSection";
import TulsaTravelTimingSection from "./components/TravelTimingSection";
import TulsaDestinationsSection from "./components/DestinationsSection";
import TulsaTestimonialsSection from "./components/TestimonialsSection";
import TulsaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import TulsaComparisonSection from "./components/ComparisonSection";
import TulsaMistakesSection from "./components/MistakesSection";
import TulsaHowItWorksSection from "./components/HowItWorksSection";
import TulsaFAQSection, { faqs } from "./components/FAQSection";
import TulsaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import TulsaFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for Tulsa travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Tulsa with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance for Tulsa residents with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Mission Trip Group Processing", description: "Group passport coordination for Tulsa church mission trips to Guatemala, Honduras, Costa Rica, and beyond." },
];

export default function TulsaPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Tulsa"
        state="Oklahoma"
        stateAbbr="OK"
        route="/cities/tulsa"
        title="Emergency Passport Tulsa, OK — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Tulsa, OK — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Tulsa energy executives, ORU/TU students, church mission groups, and families."
        geoPlacename="Tulsa, Oklahoma"
        geoPosition="36.1540;-95.9928"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Oklahoma"
        statePageRoute="/states/oklahoma"
      />
      <TulsaHeroSection />
      <TulsaStickyNav />
      <TulsaProcessingTimeSection />
      <TulsaServicesSection />
      <TulsaLocalAreaSection />
      <TulsaTravelTimingSection />
      <TulsaDestinationsSection />
      <TulsaTestimonialsSection />
      <TulsaAcceptanceFacilitiesSection />
      <TulsaComparisonSection />
      <TulsaMistakesSection />
      <TulsaHowItWorksSection />
      <TulsaFAQSection />
      <TulsaHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/tulsa" state="OK" />
      <TulsaFinalCTA />
    </div>
  );
}